import { requiredStrategy } from '../core';
import { taiwanVehicleRegistrationIssueDateFormatStrategy } from './taiwan-vehicle-registration-issue-date-format-strategy';

export const taiwanVehicleRegistrationIssueDateStrategy = (value: string) => {
  return (
    requiredStrategy(value) &&
    taiwanVehicleRegistrationIssueDateFormatStrategy(value)
  );
};
